import * as React from 'react';
import { Logo } from './brand/logo';
import { BackToLobbyButton } from './brand/backToLobbyButton';

const returnToLobby: React.EventHandler<React.MouseEvent | React.KeyboardEvent> = (e) => {
    e.preventDefault();
    window.location.replace('/');
};

interface Props {
    showBackToLobbyButton: boolean;
}

export const Header: React.FC<Props> = ({ showBackToLobbyButton }: Props) => {
    return (
        <div className="header">
            <div className="content">
                <div className="inside">
                    {showBackToLobbyButton && <BackToLobbyButton returnToLobby={returnToLobby} />}
                    <Logo backButtonVisible={showBackToLobbyButton} returnToLobby={returnToLobby} />
                </div>
            </div>
        </div>
    );
};
